import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {AdRPeriod} from '../../interfaces/ad-reports';
import {PERIODS_STATE_NAME, PeriodsState} from './periods';

export const selectPeriodsState: MemoizedSelector<object, PeriodsState> = createFeatureSelector<PeriodsState>(PERIODS_STATE_NAME);

export const selectPeriods: MemoizedSelector<object, Array<AdRPeriod>> = createSelector(
  selectPeriodsState,
  (state: PeriodsState): Array<AdRPeriod> => state.periods
);
